import { resolveCountry, separatorsByCountry } from "./FormatByCountry";

export const formatInputNoDecimal = (value: string): string => {
  const { decimal } = separatorsByCountry(resolveCountry());
  const idx = value.indexOf(decimal);
  return idx >= 0 ? value.slice(0, idx) : value;
}